import { render, staticRenderFns } from "./tzproduct10.vue?vue&type=template&id=07c704be&scoped=true"
import script from "./tzproduct10.vue?vue&type=script&lang=js"
export * from "./tzproduct10.vue?vue&type=script&lang=js"
import style0 from "./tzproduct10.vue?vue&type=style&index=0&id=07c704be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c704be",
  null
  
)

export default component.exports